import { gql } from '@apollo/client';

// WE SHOULD ADD "customerDownPayment" && "monthlyPayment" later when they're available on SCHEMA

export const US_OFFERS_SCHEMA = gql`
  query UsCustomerOffers($zipCode: String, $offerMonth: String) {
    usCustomerOffers(zipCode: $zipCode, offerMonth: $offerMonth) {
      zipClusterID
      offerModelDetail {
        modelCode
        modelYear
        bodyType
        trimline
        productModelCode
        modelCodeDescription
        msrp
        modelFamily
      }
      stackableOffers {
        offerType
        creditBonus
        programShortDescription
        offerDisclaimer
        programName
      }
      offerDisclaimer
      offerImageUrl
      featuredOfferImageUrl
      programName
      offerType
      programPriority
      programFromDate
      programToDate
      programShortDescription
      region
      zipClusterID
      aprRate
      creditBonus
      term
      totalDueAtSign
      customerDownPayment
      monthlyPayment
    }
  }
`;
